import * as Sentry from '@sentry/browser';

const getLogger = () => {
  switch (process.env.NODE_ENV) {
    case 'production':
      return serviceLogger();
    default:
      return console;
  }
};
function serviceLogger() {
  const level = process.env.LOGGER_LEVEL;
  function logToService(error) {
    if (typeof error === 'string') {
      Sentry.captureException(new Error(error));
    } else {
      Sentry.captureException(error);
    }
  }

  const loggerStub = () => {}

  return {
    fatal:  ((error) => logToService( error)),
    error:  (level !== 'FATAL' )  ? ((error) => logToService(error))  : loggerStub,
    log: (level !== 'FATAL' && level !== 'ERROR') ? ((error) => logToService(error)) : loggerStub,
    warn: (level === 'WARN' || level === 'ALL') ? ((error) => logToService(error)) : loggerStub,
  };
}



export const logger = getLogger();
